export const initializeHideIntroVideo = () => {
  (window as any).hideIntroVideo = (e?: MouseEvent) => {
    e?.preventDefault();

    document.body.classList.add("hide-intro");
    window.removeEventListener("wheel", (window as any).hideIntroVideo);
    window.removeEventListener("touchstart", (window as any).hideIntroVideo);

    const sevenDaysInSeconds = 7 * 24 * 60 * 60;
    document.cookie = `hide-intro-video=true; SameSite=Strict; max-age=${sevenDaysInSeconds}; Path=${location.pathname}; Secure`;
  };

  window.addEventListener("wheel", (window as any).hideIntroVideo, {
    passive: false,
  });
  window.addEventListener("touchstart", (window as any).hideIntroVideo, {
    passive: false,
  });
};
